var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 2.5C0.625 1.12109 1.74609 0 3.125 0H11.875C13.2539 0 14.375 1.12109 14.375 2.5V17.5C14.375 18.8789 13.2539 20 11.875 20H3.125C1.74609 20 0.625 18.8789 0.625 17.5V2.5ZM5.625 17.5C5.625 17.8438 5.90625 18.125 6.25 18.125H8.75C9.09375 18.125 9.375 17.8438 9.375 17.5C9.375 17.1562 9.09375 16.875 8.75 16.875H6.25C5.90625 16.875 5.625 17.1562 5.625 17.5ZM11.875 2.5H3.125V15H11.875V2.5Z",
    fill: "#DFEC49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneYellow);
export default __webpack_public_path__ + "static/media/phone-yellow.b0a8ab3ab43f53063604b7679b5e4e35.svg";
export { ForwardRef as ReactComponent };